<template lang="html">
  <div class="content">
    <!-- 全部评论   -->
    <div class="comment_content">
      <div class="comment_headline">
        <h3>全部评论</h3>
        <p class="comment_num" v-show="this.commentNum != undefined">({{this.commentNum}}条)</p>
      </div>
      <div class="comment_comment_mod" v-for="(a, index) in comments" :key="index">
        <div class="comment_comment">
          <div class="comment_head_left">
            <img :src="a.avatar" alt="" class="comment_head_img">
            <p>{{a.username}}</p>
          </div>
          <div class="comment_likenum">
            <img src="../../assets/image/support64.png" alt="">
            <p>{{a.likenum}}</p>
          </div>
        </div>
        <div class="comment_comment_con">
          <div>
            <p class="comment_comment_con_txt">{{a.content}}</p>
            <div class="" v-for="(b, index) in a.img" :key="index">
              <div class="comment_comment_con_img" v-html="bbc2html(b)"></div>
            </div>
          </div>


          <div class="comment_comment_con_time">
            {{ timestampToTime(a.createdtime*1000) }} · <span>回复Ta</span>
          </div>
        </div>
        <div class="comment_secound_comment" v-if="a.child && a.child.length > 0">
          <div class="" v-for="(c, index) in a.child.slice(0, 3)" :key="index">
            <span class="user_name">{{c.username}}</span> <span class="label" v-if="a.username == c.username">楼主</span>
            <span> : </span>
            <span class="user_comment_txt">{{c.content}}</span>
          </div>
          <p class="all_comment" v-if="a.child.length > 3">更多{{a.child.length-3}}条评论 > </p>
        </div>
        <WxOpenTag :extinfo="jumpTarget + '&comment_id=' +a.id" />
      </div>
    </div>
  </div>
</template>

<script>
  import WxOpenTag from '@/components/WxOpenTag'
  import {bbc2html} from '@/utils/bbcode'

  export default {
    props: ["commentNum", "comments", "jumpTarget"],
    components: {
      WxOpenTag: WxOpenTag,
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {
      // 时间戳转化
      timestampToTime(time) {
        var date = new Date(time)
        var M_ = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
        var D_ = date.getDate() + '日'
        return M_ + D_
      },
      bbc2html: bbc2html,
    }
  }
</script>

<style lang="css" scoped>
  .comment_headline {
    display: flex;
    align-items: flex-end;
  }

  .comment_num {
    margin-left: 5px;
    padding-bottom: .38rem;
    font-size: 11px;
    color: #606972;
  }

  .comment_comment_mod {
    position: relative;
    box-sizing: border-box;
    padding: 15px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  }

  .comment_comment_mod:nth-last-child(1) {
    border-bottom: none;
  }

  .comment_comment {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .comment_head_left {
    display: flex;
    align-items: center;
  }

  .comment_head_img {
    width: 3,5rem;
    height: 3.5rem;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 1.1rem;
    border: .05rem solid #E5E6EB;
  }

  .comment_likenum {
    display: flex;
    font-size: 10px;
    color: #999999
  }

  .comment_likenum img {
    width: 16px;
    height: 16px;
    margin-right: 3px;
  }

  .comment_likenum p {
    margin-top: -5px;
  }

  .comment_comment_con {
    box-sizing: border-box;
    margin-left: 45px;
    margin-top: 5px;
  }

  .comment_comment_con_txt {
    overflow: hidden;
    -webkit-line-clamp: 5;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .comment_comment_con_img /deep/ img {
    width: 180px;
    height: 110px;
    border-radius: 5px;
    object-fit: cover;
    margin-top: 10px;
  }

  .comment_comment_con_time {
    margin-top: 15px;
    font-size: 11px;
    color: #999999;
  }

  .comment_comment_con_time span {
    color: #1D2023;
  }

  .comment_secound_comment {
    box-sizing: border-box;
    margin-left: 45px;
    margin-top: 15px;
    background-color: #F8F9FB;
    padding: 8px 10px;
    border-radius: 5px;
  }

  .comment_secound_comment div {
    margin-top: 10px;
  }

  .label {
    width: 25px;
    height: 13px;
    border-radius: 12.5px;
    padding: 0 5px;
    font-size: 14px;
    border: 1px solid #979797;
    color: #979797;
  }

  .user_name {
    color: #F99E03;
    margin-right: 3px;
  }

  .user_comment_txt {
    color: #3F454B;
    margin-left: 2px;
  }

  .all_comment {
    margin-top: 5px;
    color: #F99E03;
    font-size: 14px;
  }

  .comment_content {
    /* margin-top: 10px; */
    padding: 15px;
    background-color: #fff;
  }

  .comment_comment_mod {
    box-sizing: border-box;
    padding: 15px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  }
</style>